const normalizeTimestamp = value => {
  const parsed = Date.parse(value || '');
  return Number.isNaN(parsed) ? 0 : parsed;
};

export const getLatestConversation = (conversations = []) => {
  return (
    [...conversations].sort((left, right) => {
      const rightTimestamp = Math.max(
        normalizeTimestamp(right.last_activity_at),
        normalizeTimestamp(right.last_non_activity_message_at),
        normalizeTimestamp(right.created_at),
        Number(right.id || 0)
      );
      const leftTimestamp = Math.max(
        normalizeTimestamp(left.last_activity_at),
        normalizeTimestamp(left.last_non_activity_message_at),
        normalizeTimestamp(left.created_at),
        Number(left.id || 0)
      );

      return rightTimestamp - leftTimestamp;
    })[0] || null
  );
};

export const buildWooCommerceContactRoute = (accountId, contactId) => ({
  name: 'contacts_edit',
  params: { accountId, contactId },
  query: { tab: 'woocommerce_orders' },
});

export const buildWooCommerceOrdersRoute = (
  accountId,
  hookId = '',
  query = {}
) => ({
  name: 'woocommerce_orders',
  params: {
    accountId,
    ...(hookId ? { hookId } : {}),
  },
  query,
});

export const buildWooCommerceOrderDetailsRoute = (
  accountId,
  orderRecordId,
  query = {}
) => ({
  name: 'woocommerce_order_details',
  params: { accountId, orderRecordId },
  query,
});

export const buildConversationRoute = (accountId, conversationId) => ({
  name: 'inbox_conversation',
  params: {
    accountId,
    conversation_id: conversationId,
  },
});
